
import { Component, Vue, Prop } from 'vue-property-decorator'
import HelloWorld from '@/components/HelloWorld.vue' // @ is an alias to /src
import { IDataType } from './Home'
const Mp4Icon = require('../assets/icon-mp4.png')
const ImgIcon = require('../assets/icon-img.png')
const PdfIcon = require('../assets/icon-pdf.png')
const DocIcon = require('../assets/icon-doc.png')
const FolderIcon = require('../assets/icon-folder.png')
@Component({
  components: {
  }
})
export default class Home extends Vue {
  @Prop({ default () { return '' } }) type!: string

  private mockData: IDataType[] = [
    {
      type: 'mp4',
      name: '走吧！一起用日語去旅行.mp4',
      star: true,
      lastModified: '2019/6/10',
      size: '6.5MB',
      owner: 'Paul',
      fileId: 0
    },
    {
      type: 'doc',
      name: '20191011-1020日本東京自由行.doc',
      star: false,
      lastModified: '2019/6/25',
      size: '2.3MB',
      owner: 'Paul',
      fileId: 1
    },
    {
      type: 'folder',
      name: '工作相關',
      star: false,
      lastModified: '2019/8/30',
      size: '205MB',
      owner: 'Paul',
      fileId: 2
    }
  ]

  selectListIsShow = false
  selectListStyle = {}
  activeRow = -1

  mounted () {
    window.onclick = this.clearSelectList
  }

  destroyed () {
    window.onclick = null
  }

  getPrefixImg (type: string) {
    switch (type) {
      case 'mp4':
        return Mp4Icon
      case 'doc':
        return DocIcon
      case 'folder':
        return FolderIcon
      case 'pdf':
        return PdfIcon
      case 'img':
        return ImgIcon
      default:
        break
    }
  }

  setSelectList ($ev: any, target: number) {
    console.log($ev)
    let x = $ev.pageX
    let y = $ev.pageY
    if (x + 200 > window.innerWidth) {
      x = window.innerWidth - 210
    }
    if (y + 380 > window.innerHeight) {
      y = window.innerHeight - 390
    }
    this.selectListStyle = {
      display: 'flex',
      top: y + 27 + 'px',
      left: x + 'px'
    }
    this.activeRow = target
  }
  clearSelectList () {
    this.selectListStyle = {
      display: 'none'
    }
    this.activeRow = -1
  }
}
